module.exports = "<status-widget widget-name=\"{{'dashboard.panel.events.title'|translate}}\"\n               widget-state=\"app.events\"\n               items=\"$ctrl.data\"\n               start-time=\"$ctrl.startTime\"\n               chart-colors=\"$ctrl.graphColors\"\n               widget-title-tooltip=\"{{::'dashboard.panel.events.descriptionTooltip'|translate}}\"\n               history-chart=\"true\"\n               render-counter=\"$ctrl.renderCounter\"\n               cursor-pointer=\"true\">\n</status-widget>"


//////////////////
// WEBPACK FOOTER
// ./src/azurebackup/views/dashboard/components/eventsWidget/eventsWidget.template.html
// module id = 491
// module chunks = 0